export const exchangedAmount = (rate: number, amount: string): number | string => rate ? Number(amount) * rate : amount;
